import { useEffect } from 'react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { SubmissionsList } from '@/features/forms/submissions'

export const Route = createFileRoute(
  '/_authenticated/_organization/forms/$formId/submissions/'
)({
  component: FormSubmissionsPage,
})

function FormSubmissionsPage() {
  const { formId } = useParams({ strict: false }) as { formId: string }
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  return (
    <SubmissionsList
      formId={formId}
      organizationId={activeOrganization.id}
      onViewSubmission={(submissionId) => {
        navigate({
          to: `/forms/$formId/submissions/$submissionId`,
          params: { formId, submissionId },
        })
      }}
    />
  )
}
